import { Text, TouchableOpacity, View } from "react-native";
import { MainNavProps } from "./navigation/main/MainParamList";
import BaseScreen from "./BaseScreen";
import NavBar from "../components/NavBar";
import { Str_LoginConfirm, Str_LoginConfirmTip, Str_LoginRegister, Str_QRCodeInvalid } from "../language/string_res";
import { postJson } from "../net/http";
import { showDialog, showMsgDialog } from "../components/CommonDialog";
import { useEffect, useRef } from "react";
import { black, color_main } from "../assets/style/colors";
import PCLogo from '../assets/svg/proicons_computer.svg'
export const PcLoginConfirmScreen = ({ navigation, route }: MainNavProps<'PcLoginConfirmScreen'>) => {
    const isSuc = useRef<Boolean>()
    const id = route.params.id
    useEffect(() => {
        return () => {
            if (isSuc.current !== true) {
                const body: any = { id: id, operatorType: 0 };
                postJson("/v1/pc/confirm", { body: body, useToken: true, debug: __DEV__ }).then()
            }
        }
    }, [])

    const onConfirm = async () => {
        const body: any = { id: id, operatorType: 1 };
        // 操作类型，需要移动端传入 0:拒绝PC端登录 1:同意PC端登录
        const res = await postJson("/v1/pc/confirm", { body: body, useToken: true, debug: __DEV__ })
        isSuc.current = true
        if (res.code === 0) {
            navigation.pop()
        } else {
            showMsgDialog(res?.msg || Str_QRCodeInvalid)
        }
    }


    return (
        <BaseScreen>
            <NavBar title={Str_LoginConfirm} showBack={true} />
            <View style={{ alignItems: 'center', marginHorizontal: 50, flex: 1, paddingTop: 50 }}>
                <PCLogo />
                <Text style={{ fontSize: 18, color: black, }}>{Str_LoginConfirmTip}</Text>
                <TouchableOpacity
                    activeOpacity={0.7} style={{
                        height: 50,
                        width: '100%',
                        marginTop: 30,
                        borderRadius: 20, backgroundColor: color_main,
                        justifyContent: 'center', alignItems: 'center'
                    }} onPress={onConfirm}>
                    <Text>{Str_LoginRegister}</Text>
                </TouchableOpacity>
            </View>
        </BaseScreen>
    )
}